import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: s-ki
 * id 414C136F-7BB5-47BB-BB58-136C5E1C2E5B
 * name set-merge
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-merge.svg
 * tags
 */
export const SetMergeIcon = createSvgIcon(<><path d="M2 7V9H7V7H2M12 9V11H9V13H12V15L15 12L12 9M17 9V15H22V9H17M2 11V13H7V11H2M2 15V17H7V15H2Z" /></>, 'SetMergeIcon');
export default SetMergeIcon